<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />
    <v-layout wrap>
      <v-flex xs12>
        <v-card-title class="elevation-0 pb-0">
          <v-spacer></v-spacer>
          <v-flex xl3 lg3 md4 pb-2 sm6 xs12 px-5 pt-5 pt-sm-0>
            <v-text-field
              v-model="keysearch"
              append-icon="mdi-magnify"
              label="Search Employee"
              single-line
              hide-details
              outlined
              dense
              @keyup="searchEmployee"
            ></v-text-field>
          </v-flex>
        </v-card-title>
        
        <v-layout wrap justify-start class="px-3 py-3">
          <v-flex xs12 text-center v-if="employeeList.length < 1 && !appLoading">
            <div class="pa-5">
              <v-icon size="64" color="grey lighten-1">mdi-account-off</v-icon>
              <h3 class="grey--text mt-3">No Employees Found</h3>
            </div>
          </v-flex>
          
          <v-flex
            v-else
            xs12
            sm6
            md4
            lg3
            xl2
            v-for="(item, i) in employeeList"
            :key="i"
            pa-3
          >
            <v-card
              class="mx-auto employee-card rounded"
              elevation="1"
              outlined
              hover
              style="border-color: #e0e0e0; height: 100%; display: flex; flex-direction: column;"
            >
              <v-card-text class="text-left pt-4 pb-1" style="flex-grow: 1;">
                <h3 class="text-h6 mb-1 showLine" style="color: #333333; font-weight: 400; font-size: 0.9rem !important;">
                  {{ item.name || item.employeeId || 'Unknown Employee' }}
                </h3>
              </v-card-text>
              
              <v-card-actions class="justify-center pb-3 pt-1">
                <router-link :to="{ path: '/viewdocument', query: { id: item._id } }" style="text-decoration: none;">
                  <v-btn
                    outlined
                    color="success"
                    small
                    width="120"
                    class="font-weight-bold"
                    style="letter-spacing: 1px;"
                  >
                    VIEW
                  </v-btn>
                </router-link>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>

        <div class="text-center pt-2 pb-5" v-if="pages > 1">
          <v-pagination
            v-model="currentPage"
            :length="pages"
            @input="getData"
            circle
            color="primary"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      employeeList: [],
      keysearch: "",
      currentPage: 1,
      pages: 0,
      limit: 20,
      searchTimeout: null
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    searchEmployee() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.getData();
      }, 500);
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/employees/getalllist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          keyword: this.keysearch,
          page: this.currentPage,
          limit: this.limit
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.data) {
            this.employeeList = response.data.data;
            let totalData = response.data.length || response.data.totalCount || this.employeeList.length;
            this.pages = Math.ceil(totalData / this.limit);
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
.employee-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid #e0e0e0;
}
.employee-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
}
.bg-light {
  background-color: #f8f9fa;
}
.showLine {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
.itemHeading {
  font-size: 24px;
  font-weight: 700;
  color: #2c3e50;
}
</style>